export interface Shape {
  id: string;
  translateX: number;
  translateY: number;
  width: number;
  height: number;
  x: number;
  y: number;
  filter?: string;
  mass?: number;
  verticalAnchor?: 'top' | 'bottom';
  frostedPolygonStyles?: React.CSSProperties;
  // From 0 to 1, which will be normalized later to a tweakable duration:
  fadeScale?: number;
  mobile?: {
    translateX: number;
    translateY: number;
  };
}

const SHAPES: Array<Shape> = [
  {
    id: 'blue-spiral',
    x: 84,
    y: 172,
    width: 161,
    height: 210,
    translateX: -450,
    translateY: 90,
    fadeScale: 0.45,
    mobile: {
      translateX: 130,
      translateY: -16,
    },
  },
  {
    id: 'cloud-guy',
    x: 60,
    y: 685,
    width: 260,
    height: 230,
    translateX: -950,
    translateY: 230,
    fadeScale: 1,
    mobile: {
      translateX: 270,
      translateY: 20,
    },
  },
  {
    id: 'd8',
    x: 300,
    y: 470,
    width: 187,
    height: 183,
    translateX: -650,
    translateY: 95,
    fadeScale: 0.75,
    mobile: {
      translateX: 50,
      translateY: 165,
    },
  },
  {
    id: 'pink-glassball',
    x: 516,
    y: 242,
    width: 170,
    height: 170,
    translateX: 180,
    translateY: -20,
    fadeScale: 0.9,
    mobile: {
      translateX: 1000,
      translateY: -1000,
    },
  },
  {
    id: 'diamond',
    x: 820,
    y: 70,
    width: 250,
    height: 180,
    translateX: -750,
    translateY: 290,
    fadeScale: 0.7,
    mobile: {
      translateX: -220,
      translateY: 470,
    },
  },
  {
    id: 'nerds-ball',
    x: 777,
    y: 444,
    width: 150,
    height: 150,
    translateX: -850,
    translateY: 110,
    fadeScale: 0.9,
  },
  {
    id: 'purple-clay-ball',
    x: 1050,
    y: 500,
    width: 120,
    height: 120,
    translateX: 715,
    translateY: 218,
    fadeScale: 0.9,
  },
  {
    id: 'dodecahedron',
    x: 1188,
    y: 290,
    width: 128,
    height: 128,
    translateX: 330,
    translateY: 250,
    fadeScale: 0.5,
    mobile: {
      translateX: -280,
      translateY: 130,
    },
  },
  {
    id: 'jujube',
    x: 1290,
    y: 610,
    width: 146,
    height: 146,
    translateX: 951,
    translateY: 180,
    fadeScale: 1,
    mobile: {
      translateX: -390,
      translateY: 190,
    },
  },
  {
    id: 'purple-glassball',
    x: 1524,
    y: 355,
    width: 175,
    height: 175,
    translateX: -330,
    translateY: 340,
    fadeScale: 0.6,
    mobile: {
      translateX: 1000,
      translateY: -1000,
    },
  },
  {
    id: 'torus',
    x: 1675,
    y: 568,
    width: 260,
    height: 230,
    translateX: 320,
    translateY: 310,
    fadeScale: 0.6,
    mobile: {
      translateX: 80,
      translateY: 420,
    },
  },
  {
    id: 'tube',
    x: 1880,
    y: 300,
    width: 260,
    height: 280,
    translateX: -150,
    translateY: 120,
    fadeScale: 0.3,
    mobile: {
      translateX: -250,
      translateY: 220,
    },
  },
  {
    id: 'star',
    x: 2200,
    y: 588,
    width: 188,
    height: 200,
    translateX: 490,
    translateY: 140,
    fadeScale: 0.4,
    filter: 'brightness(120%)',
    mobile: {
      translateX: -190,
      translateY: 50,
    },
  },
  {
    id: 'purple-cube',
    x: 2084,
    y: 724,
    width: 115,
    height: 115,
    translateX: -700,
    translateY: 0,
    fadeScale: 0,
    mobile: {
      translateX: -146,
      translateY: 186,
    },
  },
  {
    id: 'heart',
    x: 2373,
    y: 192,
    width: 184,
    height: 174,
    translateX: -520,
    translateY: 250,
    fadeScale: 0.6,
    mobile: {
      translateX: 160,
      translateY: 130,
    },
  },
  {
    id: 'thimble',
    x: 2495,
    y: 596,
    width: 130,
    height: 140,
    translateX: 250,
    translateY: 120,
    fadeScale: 1,
    mobile: {
      translateX: -270,
      translateY: -10,
    },
  },
  {
    id: 'bracelet',
    x: 2688,
    y: 162,
    width: 200,
    height: 260,
    translateX: 630,
    translateY: 100,
    fadeScale: 0.8,
    mobile: {
      translateX: 250,
      translateY: 190,
    },
  },
  {
    id: 'mirrorball',
    x: 2700,
    y: 427,
    width: 410,
    height: 410,
    translateX: 500,
    translateY: 300,
    fadeScale: 0.5,
    mobile: {
      translateX: -500,
      translateY: 50,
    },
  },
  {
    id: 'egg',
    x: 2924,
    y: 120,
    width: 218,
    height: 278,
    translateX: -1180,
    translateY: 140,
    fadeScale: 1,
  },
];

export default SHAPES;
